import React, { useState, useEffect } from "react";
import deleteApiApp from "../../../assets/images/delete-api-app.svg";

const DeleteModal = ({ deleteAppModal, showDeleteModal, deleteApp }) => {
  const [appData, setAppData] = useState();

  useEffect(() => {
    setAppData(deleteAppModal.appData);
  }, [deleteAppModal]);

  return (
    <div id={deleteAppModal.isOpen ? "show_modal" : "hide_modal"}>
      <div class="modal_deleteApp">
        <div class="modal_delete_content  delete_modal">
          <div className="apiConnectWrap_lessWidth deleteApiApp">
            <div className="apiConnect delete_apiConnect">
              <img
                src={deleteApiApp}
                alt="delete api connect"
                className="connectImg"
              />
              <h1>Delete {appData && appData.appNm}</h1>
              <p>
                Are you sure you want to delete the app. You would loose all the
                information and data related to it.
              </p>
              <div className="display-space-evenly">
                <button
                  className="custom-btn border-btn"
                  onClick={() =>
                    showDeleteModal(false, showDeleteModal.appData)
                  }
                >
                  <span>Cancel</span>
                </button>
                <button
                  className="custom-btn block-btn"
                  onClick={() => deleteApp(appData)}
                >
                  <span>Yes, Delete</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
